// extracted by mini-css-extract-plugin
export default {"interestWrapper":"ActivitiesInterest_interestWrapper__Jedgv","activitiesInterest":"ActivitiesInterest_activitiesInterest__V2Hkv","round":"ActivitiesInterest_round__PCNxL"};